import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { MdCheck, MdClose, MdDescription, MdChatBubbleOutline, MdAccessTime } from 'react-icons/md';
import './style.scss';

const { objectOf, object, oneOfType, string } = PropTypes;

export default function TimesheetAuditTrailItem({ message }) {
  const isMessage = message.title === 'Message sent';
  const isCandidate = !!message.candidate && !message.admin;
  const title = (message.title || '').toLowerCase();
  const approved = title === 'timesheet approved';
  const rejected = title === 'timesheet rejected';
  let Icon = MdDescription;
  if (isMessage) Icon = MdChatBubbleOutline;
  else if (approved) Icon = MdCheck;
  else if (rejected) Icon = MdClose;
  else if (title === 'timesheet created') Icon = MdAccessTime;
  const actor = message.admin?.display_name || message.candidate?.name || 'System';
  const sentAt = moment.utc(message.sent_at).local();

  return (
    <article className={`timesheet-audit${rejected ? ' timesheet-audit--rejected' : ''}${isMessage ? ' timesheet-audit--message' : ''}${isCandidate ? ' timesheet-audit--candidate' : ''}`}>
      <span className={`timesheet-audit__icon${approved ? ' timesheet-audit__icon--approved' : ''}${rejected ? ' timesheet-audit__icon--rejected' : ''}`} aria-hidden="true"><Icon size={20} /></span>
      <div className="timesheet-audit__card">
        <h5 className="timesheet-audit__title">{message.title}</h5>
        <p className="timesheet-audit__text">{message.text}</p>
        <p className="timesheet-audit__meta">
          <span>From <strong>{actor}</strong></span>
          <span aria-hidden="true"> · </span>
          <time dateTime={sentAt.toISOString()}>{sentAt.format('DD MMM YYYY, HH:mm')}</time>
        </p>
      </div>
    </article>
  );
}

TimesheetAuditTrailItem.propTypes = {
  message: objectOf(oneOfType([string, object])),
};
TimesheetAuditTrailItem.defaultProps = { message: {} };
